var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    serifId: "Layer 2",
    transform: "matrix(1.01749,0,0,1.01749,-0.260334,-0.462242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path945",
    d: "M15.982,0.454C15.982,0.454 15.981,0.454 15.981,0.454C7.354,0.454 0.256,7.553 0.256,16.179C0.256,16.179 0.256,16.179 0.256,16.179C0.263,19.473 1.304,22.683 3.233,25.353L3.458,25.121L12.747,15.875L12.747,12.165L12.774,12.165C11.973,11.763 11.466,10.941 11.464,10.046C11.464,8.743 12.537,7.671 13.841,7.671C15.145,7.671 16.218,8.743 16.218,10.046C16.217,10.974 15.672,11.819 14.827,12.204L14.764,16.74L4.595,27.017C5.176,27.62 5.804,28.177 6.474,28.68L6.63,28.532L18.773,16.496C18.623,16.18 18.544,15.834 18.543,15.484C18.543,14.182 19.616,13.11 20.92,13.11C22.224,13.11 23.297,14.182 23.297,15.484C23.297,16.787 22.224,17.859 20.92,17.859C20.765,17.859 20.61,17.844 20.458,17.814L8.632,29.688L8.38,29.94C9.165,30.368 9.986,30.729 10.833,31.018L11.017,30.848L19.014,23.049C18.894,22.76 18.832,22.451 18.832,22.139C18.832,20.836 19.905,19.764 21.209,19.764C22.513,19.764 23.586,20.836 23.586,22.139C23.586,23.441 22.513,24.513 21.209,24.513C20.988,24.513 20.768,24.482 20.556,24.422L13.243,31.648C14.147,31.814 15.063,31.899 15.982,31.904C24.608,31.904 31.706,24.805 31.706,16.179C31.706,7.553 24.608,0.455 15.982,0.454Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-31.45,31.45,-31.45,-31.45,31.7059,0.454297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(227,73,248)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(128,0,195)",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.ab889b68978ea91efef6fef62de0c053.svg";
export { ForwardRef as ReactComponent };